// =========================================gallery Slides Above Footer=======================================================//
$(document).ready(function(){
  $('.gallery_slides').slick({
    arrows: false,
    centerPadding:"20px",
    autoplay: true,
    autoplaySpeed: 4000,
  });
//========================================End gallery Slides Above Footer=======================================================//
//========================================Secondary Hover Image=================================================================//
// if($(window).width()< 768){
//     setInterval(function(){
//       setTimeout(function(){
//         $('.image-swap').find('.images-one').fadeIn('slow');
//         $('.image-swap').find('.images-two').fadeOut('slow');
//       },0)
//       setTimeout(function(){
//         $('.image-swap').find('.images-one').fadeOut('slow');
//         $('.image-swap').find('.images-two').fadeIn('slow');
//       },2500)
//     },5000);
// }
  //==========================================END Secondary Hover Image ========================================================//
//==========================Added tooltip in product page or cart page==========================
  $('[data-toggle="tooltip"]').tooltip();   
//===============================end here============================================
//===============================Added For Close cart Drawer=========================
  $('a.close-cart.close').on('click', function(){
    $(this).parents().find('#dropdown-cart').removeClass('menu-open');
  });
//===============================end here============================================  
//===============================Mobile Menu ============================================
  $(".mobile__menu_label_2").hide();
    $('.mobile__menu_label li').click(function () {
     // $(this).find(".mobile__menu_label_2").show();
        $(this).find(".mobile__menu_label_2").toggle();
    });
// =================================sidebar filter close on select======================
  $('.customize-list-tags li a,.list-tags li label').click(function(){
     $(this).parents().find('a.close-sidebar.close').trigger('click')
  });
//===============================end here===============================================

//   Related Metafield Slider
   $('.metaRelatedItems').slick({
     arrows: true,
     slidesToShow: 4,
     slidesToScroll: 1,
     prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-angle-left metaRelatedItems-left" aria-hidden="true"></i></button>',
     nextArrow:'<button type="button" class="slick-next"><i class="fa fa-angle-right metaRelatedItems-right" aria-hidden="true"></i></button>',
      responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
  });

//   custom code for getting information from cart
//   setTimeout(function(){
//   $.ajax({
//    url:'https://artkaratstore.myshopify.com/cart',
//    type:'GET',
//    success: function(data){
//        //$('#shopify-section-cart-template').html(data);
//      //console.log(data);
//    }
// });
//   },3000);
  
});
// =============================================Instafeed ====================================================================== 
$(window).on("load",function(){
 $( "<p class='shop_now_insta'>Shop Now</p>" ).insertAfter( ".mobWidth img" );
});
// ==================================End Instagran ================================================================

document.addEventListener("DOMContentLoaded", function() {
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateLoop',
    pagination: '.AjaxinatePagination'
  });
})
document.addEventListener('product:added', function(event) {
  alert();
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
  });
// ===============================image remove mobile/desktop =============================================================


 
